import imageCompression from 'browser-image-compression';

export const getBase = async (file: any) => {
    const imageFile = file;
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1950,
      useWebWorker: true
    }
    let compressedFile = await imageCompression(imageFile,options );
    var file1 = new File([compressedFile], imageFile.name, 
      {
        type: imageFile.type, 
        lastModified: Date.now()
      });
    return file1;
  };

  export const getBase64 = async (file:any) => {
    const imageFile = file;
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1950,
      useWebWorker: true
    }
    const compressedFile = await imageCompression(imageFile, options);
    let mainFile = await getBase64__(compressedFile); // write your own logic
    return mainFile;
  };

  export const getBase64__ = (file:any) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });